// 校验是否中英文 true: 中文 false: 英文
export let checkLanguage = () => {
    let siteId = localStorage.getItem('siteId')
    if (!siteId) {
        localStorage.setItem('siteId', '1422454440404713472')
    }
    return localStorage.getItem('siteId') === '1422454440404713472' ? true : false
}